module.exports = __webpack_public_path__ + "static/img/brees-2018-slide-2.d208b0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-slide-2.jpg
// module id = olNC
// module chunks = 1